
import { onMounted, computed, SetupContext, reactive } from 'vue'
export default {
  name: 'InputSelectbox',

  props: {
    id: String,
    name: String,
    options: Array,
    addClass: Object,
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    req: {
      type: Boolean,
      default: false
    },
    value: String
  },

  setup(props: any, context: SetupContext) {
    const state = reactive({
      isSelected: false
    })

    const classObject = computed(() => {
      return {
        selectbox: true,
        disabled: props.disabled,
        req: props.req,
        val: props.value || state.isSelected,
        error: props.error,
        ...props.addClass
      }
    })

    const updateValue = (e: any) => {
      context.emit('selection-change', e.target.value)
      if (e.target.value) {
        state.isSelected = true
      }
    }

    onMounted(() => {
      const selectedOption = props.options.filter((option: any) => {
        return option.selected === true
      })

      if (selectedOption.length > 0) {
        context.emit('selection-change', selectedOption[0].value)
        if (selectedOption[0].value) {
          state.isSelected = true
        }
      }
    })
    return {
      classObject,
      updateValue
    }
  }
}
